// Debugging confirmation
console.log('✅ Listing Page Builder loaded successfully!');

//import { getRegularPageLayoutContentByFolderPath } from "../js/build-manager-utils.js";
//import { buildMasterPageByMasterLayoutBuildManager } from "../js/build-manager-master-pages.js";
////import { buildComponentCatalogListing } from "../builders-components/catalog/catalog-listing.js";

// Listing Page Builder
export async function buildContentListingPage(params, valuesInUrl) {
  console.log(
    `🏗️ Listing Page Builder - Starting Building Listing Page - params: ${params} , valuesInUrl: ${valuesInUrl}`
  );

  try {
    // Parallel import of all dependencies
    const [
      { buildMasterPageByMasterLayoutBuildManager },
      { getRegularPageLayoutContentByFolderPath },
      { buildComponentCatalogListing },
      { isNodeEnvironment },
    ] = await Promise.all([
      import(
        /* webpackChunkName:"build-manager-master-pages", webpackPrefetch: true */ '../js/build-manager-master-pages.js'
      ),
      import(
        /* webpackChunkName:"build-manager-utils", webpackPrefetch: true */ '../js/build-manager-utils.js'
      ),
      import(
        /* webpackChunkName:"catalog-listing", webpackPrefetch: true */ '../builders-components/catalog/catalog-listing.js'
      ),
      import(
        /* webpackChunkName:"utils-fetch-data-json", webpackPrefetch: true */ '../js/utils-fetch-data-json.js'
      ),
    ]);

    // Fetch layouts concurrently
    const [masterLayout, pageLayout, pageComponent] = await Promise.all([
      buildMasterPageByMasterLayoutBuildManager('master-layout-shop'),
      getRegularPageLayoutContentByFolderPath('pages/catalog-pages/listing'),
      buildComponentCatalogListing(params, valuesInUrl),
    ]);

    // Insert component into page layout
    const content = pageLayout.replace('{{{ content }}}', pageComponent);

    // if (!isNodeEnvironment()) {
    // Client-side rendering structure
    const masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;
    const pageContentX = `<div id="x-my-page-content">${content}</div>`;

    console.log(`🔄 buildContentListingPage Builder - Finished (Client-side)`);
    return {
      masterPageName: 'master-layout-shop',
      masterPageHtml: masterLayoutX,
      pageContentHtml: pageContentX,
    };
    //} else {
    //    // Server-side rendering
    //    const result = masterLayout.replace("{{{ content }}}", content);

    //    console.log(`🔄 buildContentListingPage Builder - Finished (Server-side)`);
    //    return result;
    //}

    //// Build the master page layout
    //let masterPageLayoutContent = await buildMasterPageByMasterLayoutBuildManager("master-layout-shop");

    //// Get the page layout content
    //let regularPageLayoutContent = await getRegularPageLayoutContentByFolderPath("pages/catalog-pages/listing");

    //const [{ buildComponentCatalogListing }] =
    //    await Promise.all([
    //        // 2. this import() tells Webpack “please code-split this module into its own chunk named “home-trending””
    //        import(/* webpackChunkName:"listing-page" */ "../builders-components/catalog/catalog-listing.js")
    //    ]);

    //let mainPageElement = await buildComponentCatalogListing(params, valuesInUrl);

    //regularPageLayoutContent = regularPageLayoutContent.replace("{{{ content-catalog-listing }}}", mainPageElement);

    //// Replace content placeholder with actual content
    //let result = masterPageLayoutContent.replace("{{{ content }}}", regularPageLayoutContent);

    //console.log(`🔄 Listing Page Builder - End Building Listing Page`);
    //return result;
  } catch (error) {
    console.error('❌ Error building Listing page content:', error);
    return 'Error loading Listing page content.';
  }
}
